import styled from '@emotion/styled'
import { AiOutlineLeft } from 'react-icons/ai'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import TitleHeader from '../../../components/app-layout/AppHeader/TitleHeader'
import * as paths from '../../../constant/path'
import AddressForm from '../AddressForm'
import { useCreateAddress } from '../../../services/address/address-query'
import { AddressValues } from '../../../services/address/address-typed'
import { useHistory } from 'react-router'

const Layout = styled.div`
  padding: 8px 0;
  ${mobile} {
    margin-top: 64px;
  }
`

const ShopAddressStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 24px;
  ${mobile} {
    display: block;
    padding-top: 16px;
  }
`

const ShopCartNewAddress = () => {
  const { isMobile } = useScreen()
  const history = useHistory()
  const { mutate: createAddress } = useCreateAddress()
  return (
    <Layout>
      {isMobile && (
        <TitleHeader
          title="ที่อยู่จัดส่งสินค้าใหม่"
          icon={<AiOutlineLeft />}
          path={paths.shopCartAddresses()}
        />
      )}
      <ShopAddressStyled>
        <AddressForm
          onSubmit={(form: AddressValues) => {
            createAddress(form, {
              onSettled: () => {
                history.push(paths.shopCartAddresses())
              },
            })
          }}
        />
      </ShopAddressStyled>
    </Layout>
  )
}

export default ShopCartNewAddress
